import React from 'react'
import { array, node, func, object, bool } from 'prop-types'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../utils/constants'
import ListItem from './ListItem'

const List = ({ onClick, items = EMPTY_ARRAY, children, isInnerHtml = false, listItemProps = EMPTY_OBJECT, ...rest }) => (
  <ul className='ad-list' {...rest}>
    {children}
    {items.map((item, index) =>
      <ListItem item={item} index={index} onClick={onClick} isInnerHtml key={item.name + index} listItemProps={listItemProps} />
    )}
  </ul>
)

List.propTypes = {
  items: array,
  children: node,
  listItemProps: object,
  isInnerHtml: bool,
  onClick: func
}

export default React.memo(List)
